'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reducer;

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

var _timeOnPageTriggerActionTypes = require('../constants/timeOnPageTriggerActionTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (0, _immutable.Map)({
  timeoutId: 0
});

var reducer = (_reducer = {}, _defineProperty(_reducer, _timeOnPageTriggerActionTypes.ADD_TIME_ON_PAGE_TRIGGER, function (state, action) {
  var timeoutId = action.payload.timeoutId;


  return state.set('timeoutId', timeoutId, state);
}), _defineProperty(_reducer, _timeOnPageTriggerActionTypes.REMOVE_TIME_ON_PAGE_TRIGGER, function (state) {
  return state.set('timeoutId', 0, state);
}), _reducer);

exports.default = (0, _reduxActions.handleActions)(reducer, initialState);
module.exports = exports['default'];